import React, { useEffect, useState } from "react";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  TextField,
  IconButton,
  Popper,
  Fade,
  Paper,
  Button,
} from "@mui/material";
import { FlexBox } from "components/Wrappers/FlexBox/FlexBox";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import dayjs from "configs/dayjs.config";

import CloseIcon from "@mui/icons-material/Close";

export const FilterSortTableDashboard = ({
  records,
  setOutputRecords,
  allowedFilters,
}) => {
  const [sortBy, setSortBy] = useState();
  const [sortType, setSortType] = useState("");
  const [filterBy, setFilterBy] = useState();
  const [filterValue, setFilterValue] = useState("");
  const [resetSortFilter, setResetSortFilter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  useEffect(() => {
    setOutputRecords(records);
  }, [records]);

  useEffect(() => {
    handleFilterSort();
  }, [sortType, resetSortFilter]);

  const handleIconClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleFilterSort = () => {
    let updatedRecords = [...records];
    if (filterBy && filterValue) {
      updatedRecords = [
        ...[...updatedRecords].filter((item) => {
          const val = item[filterBy];
          if (dayjs(val).isValid() && !isNaN(Date.parse(val))) {
            const formattedVal = dayjs(val).format("YYYY-MM-DD").toLowerCase();
            return formattedVal.includes(filterValue.toLowerCase());
          }
          if (typeof val === "number") {
            return val === Number(filterValue);
          }

          return String(val).toLowerCase().includes(filterValue.toLowerCase());
        }),
      ];
    }

    if (sortBy) {
      if (sortType === "ASC") {
        updatedRecords.sort((a, b) => {
          const aVal = a[sortBy];
          const bVal = b[sortBy];
          if (dayjs(aVal).isValid()) {
            return dayjs(aVal).diff(dayjs(bVal), "day");
          }
          if (typeof aVal === "number" && typeof bVal === "number") {
            return aVal - bVal;
          }

          return String(aVal).localeCompare(String(bVal));
        });
      } else {
        updatedRecords.sort((a, b) => {
          const aVal = a[sortBy];
          const bVal = b[sortBy];
          if (dayjs(aVal).isValid()) {
            return dayjs(bVal).diff(dayjs(aVal), "day");
          }
          if (typeof aVal === "number" && typeof bVal === "number") {
            return bVal - aVal;
          }

          return String(bVal).localeCompare(String(aVal));
        });
      }
    }
    setOutputRecords(updatedRecords);
    setAnchorEl(null);
  };
  const handleClearFilterSort = () => {
    setSortBy("");
    setSortType("");
    setFilterBy("");
    setFilterValue("");
    setAnchorEl(null);
    setResetSortFilter(!resetSortFilter);
  };

  return (
    <>
      <IconButton onClick={handleIconClick}>
        <FilterAltIcon fontSize="small" />
      </IconButton>
      <Popper
        sx={{ zIndex: 1200 }}
        open={open}
        anchorEl={anchorEl}
        placement="bottom-start"
        transition
      >
        {({ TransitionProps }) => (
          <Fade {...TransitionProps} timeout={350}>
            <Paper>
              <FlexBox justifyContent="flex-end" sx={{ mt: -2, mr: -2 }}>
                <IconButton onClick={() => setAnchorEl(null)}>
                  <CloseIcon size="small" />
                </IconButton>
              </FlexBox>
              <FlexBox width="40vw" minWidth={350}>
                <FormControl size="small" sx={{ width: "50%" }}>
                  <InputLabel>Sort By</InputLabel>
                  <Select
                    value={sortBy || ""}
                    label="Sort By"
                    onChange={(e) => setSortBy(e.target.value)}
                  >
                    {allowedFilters.map((option) => (
                      <MenuItem key={option.key} value={option.key}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ width: "50%", ml: 2 }}>
                  <InputLabel>Filter By</InputLabel>
                  <Select
                    value={filterBy || ""}
                    label="Filter By"
                    onChange={(e) => setFilterBy(e.target.value)}
                  >
                    {allowedFilters.map((option) => (
                      <MenuItem key={option.key} value={option.key}>
                        {option.value}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </FlexBox>
              <FlexBox width="40vw" minWidth={350} mt={2}>
                <FormControl size="small" sx={{ width: "50%" }}>
                  <InputLabel>Sort Type</InputLabel>
                  <Select
                    value={sortType || ""}
                    label="Sort Type"
                    onChange={(e) => setSortType(e.target.value)}
                  >
                    <MenuItem key="ASC" value="ASC">
                      ASC
                    </MenuItem>
                    <MenuItem key="DESC" value="DESC">
                      DESC
                    </MenuItem>
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ width: "50%", ml: 2 }}>
                  <TextField
                    label="Filter Value"
                    variant="outlined"
                    value={filterValue || ""}
                    fullWidth
                    size="small"
                    mt={2}
                    onChange={(e) => setFilterValue(e.target.value)}
                    onKeyUp={(e) => e.key === "Enter" && handleFilterSort()}
                    disabled={!filterBy}
                  />
                </FormControl>
              </FlexBox>
              <FlexBox>
                <Button
                  variant="text"
                  fullWidth
                  onClick={() => handleClearFilterSort()}
                >
                  Clear Filter
                </Button>
              </FlexBox>
            </Paper>
          </Fade>
        )}
      </Popper>
    </>
  );
};
